<template>
  <div class="auth-container">
    <router-view />
  </div>
</template>